import { useLoadPolicyHolderReferenceDataStore } from '../Stores/useLoadPolicyHolderReferenceDataStore'

export const useNationality = () => {
  const { policyHolderReferenceData } = useLoadPolicyHolderReferenceDataStore()
  const nationalities = policyHolderReferenceData?.nationalities

  const getNationality = (nationalityId: string) => {
    return nationalities?.find(
      (nationality) => nationality.idElement === nationalityId,
    )
  }

  return {
    getNationality,
  }
}
